module.exports = __webpack_public_path__ + "static/media/feature2showcase.bea9025b.png";